import { TableCell, TableRow, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import { memo } from 'react';
import { NumericFormat } from 'react-number-format';

export const PaymentRow = memo(
  ({
    row,
    index,
    handlePaymentDate,
    handlePaymentPrice,
    handleDateError,
    stablePaymentList,
    currency,
  }) => {
    const isLastRow = index === stablePaymentList.length - 1;

    return (
      <TableRow hover tabIndex={-1}>
        <TableCell>{row.id}</TableCell>

        {/* Sana */}
        <TableCell>
          <div className='w-[250px] -my-2'>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                value={row.date ? moment(row.date) : null}
                onChange={(newValue) => {
                  const formatted = newValue
                    ? moment(newValue).format('YYYY-MM-DD')
                    : '';
                  handlePaymentDate(formatted, row.id);
                }}
                views={['year', 'month', 'day']}
                inputFormat='DD/MM/yyyy'
                renderInput={(params) => (
                  <TextField
                    {...params}
                    color='formColor'
                    variant='outlined'
                    fullWidth
                    error={handleDateError(row.date)}
                  />
                )}
              />
            </LocalizationProvider>
          </div>
        </TableCell>

        {/* Qoldiq */}
        <TableCell>
          <div className='w-[250px] -my-2'>
            <NumericFormat
              value={row.left}
              displayType='text'
              thousandSeparator=' '
              decimalScale={3}
              suffix={currency === '1' ? ' $' : ' UZS'}
            />
          </div>
        </TableCell>

        {/* To'lov summasi */}
        <TableCell>
          <div className='w-[250px] -my-2'>
            <NumericFormat
              value={row.sum}
              onChange={(e) => {
                const val = e.target.value
                  ? parseFloat(e.target.value.replace(/\s/g, ''))
                  : 0;
                handlePaymentPrice(val, row.id);
              }}
              customInput={TextField}
              color='formColor'
              variant='outlined'
              fullWidth
              thousandSeparator=' '
              decimalScale={3}
              allowNegative={false}
              inputProps={{
                readOnly: isLastRow, // Oxirgi qator o'zgartirilmaydi
              }}
            />
          </div>
        </TableCell>
      </TableRow>
    );
  },
);
